<template>
  <div class="misc-wrapper">

    <b-link class="brand-logo">
      <h2 class="brand-text text-primary ml-1">
        <code
            class="text-primary bg-transparent"
            translate="no"
        >goaligner<small>®</small></code>
      </h2>
    </b-link>

    <div class=" p-2 p-sm-3">
      <div class="text-center">
        <h2 class="mb-1">
          Agenda tus procedimientos 🚀
        </h2>
        <p class="mb-3">
          ¡Listo! Al iniciar sesión podrás comenzar a agendar a tus pacientes de forma rápida y sencilla.
        </p>
      </div>

      <create-schedule-card />

    </div>

  </div>
</template>

<script>
import {
  BRow, BCol, BLink, BButton, BImg, BForm, BFormInput,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import CreateScheduleCard from './CreateScheduleCard.vue'

export default {
  components: {
    BFormInput,
    BForm,
    BImg,
    BButton,
    VuexyLogo,
    BLink,
    BRow,
    BCol,

    CreateScheduleCard,
  },
}
</script>

<style lang="scss">

@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/page-misc.scss';

</style>
